<template>
  <stat-item
    class="showcase-owner-item"
    :as="isPublic ? 'nuxt-link' : 'router-link'"
    label="Owner"
    :value="owner.displayName || 'Anonymous'"
    :to="`/showcase/${owner.uid}`"
  >
    <template #before>
      <avatar v-if="owner.photoUrl" :image-url="owner.photoUrl" />
    </template>
  </stat-item>
</template>

<script>
import Avatar from './Avatar';
import StatItem from './StatItem';

export default {
  components: {
    Avatar,
    StatItem,
  },

  props: {
    owner: Object,
    isPublic: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.showcase-owner-item {
  --avatar-size: 20px;
  --stat-item-label-margin: #{$gp * 0.35};
}
</style>
